import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import AccountingSidebar from "../AccountingSidebar/AccountingSidebar";

const AccountingLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<AccountingSidebar />}>{children}</NavigationBar>
);

export default AccountingLayout;

